<div class="bg-th-yellow mt-0 container-fluid">

    <div class=" d-flex justify-content-between align-content-center h-35">

        <i class="fa fa-arrow-left text-dark my-auto pointer" [routerLink]="['/']"></i>

        <span class="my-auto f16 fw-bold me-2"> سرجمع تقسیمات سیاسی </span>

    </div>

</div>

<main style="direction: rtl;" class="py-4 px-2">

    <!-- جدول اطلاعات -->

    <div class="border border-2 p-2">

        <div class="row gx-0 gy-2 gy-md-0">

            <!-- جستجو -->

            <div class="col-10">

                <input class="w-100 form-control" placeholder="جستجو کنید ..." #searchTerm
                    (keyup)="filter_list($event.target)">

            </div>

            <!-- خروجی اکسل -->

            <div class="col-2 px-2">

                <button class="btn btn-success" (click)="exportExcel('Export_Excel')">

                    خروجی اکسل

                </button>

            </div>

        </div>

        <div class="section border border-2 mt-2" style="height:calc(100vh - 235px);overflow: auto;">

            <table class="col-12 table table-striped rounded-3" id="Export_Excel">

                <thead>

                    <tr class="">

                        <th class="text-center col-1"> # </th>

                        <th class="text-center"> کد دهیاری </th>

                        <th class="text-center"> استان </th>

                        <th class="text-center"> شهرستان </th>

                        <th class="text-center"> بخش </th>

                        <th class="text-center"> دهستان </th>

                        <th class="text-center"> آبادی </th>

                        <th class="text-center"> تعداد خودرو </th>

                    </tr>

                </thead>

                <tbody>

                    <tr class="col-12 text-center" *ngFor="let item of lst_Report;let i = index">

                        <th> {{ i + 1 | faNum }} </th>

                        <td [innerHTML]="highlightText(item.strDehyarCode,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strState,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strTownship,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strSection,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strDehestan,searchTerm.value) | faNum"> </td>

                        <td [innerHTML]="highlightText(item.strAbadi,searchTerm.value) | faNum"> </td>

                        <td> {{ item.iCount | faNum }} </td>

                    </tr>

                </tbody>

            </table>

        </div>

    </div>

</main>